import { type DialogProps } from '@radix-ui/react-dialog'

import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/dialog/dialog'

import { cn } from '@/lib/utils'

export interface CaseStatusGuideDialogProps {
  open: boolean
  onClose: () => void
}

export const CaseStatusGuideDialog = ({ open, onClose }: CaseStatusGuideDialogProps) => {
  const handleOpenChange: DialogProps['onOpenChange'] = (open) => {
    if (!open) {
      onClose()
      return
    }
  }

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Active Cases / Inactive Case</DialogTitle>
          <DialogDescription className={cn('sr-only')}>Learn more about active and inactive cases.</DialogDescription>
        </DialogHeader>
        <div className={cn('space-y-6')}>
          <div>
            <b>Active Cases</b> count toward the plan&apos;s case quota and are continuously tracked from government
            agency sites (USCIS, DOL, NVC). The status of these cases will be regularly updated, and alerts can be set
            for various case events to receive email notifications.
          </div>
          <div>
            <b>Inactive Cases</b> do not count toward the plan&apos;s case quota, as these cases have completed their
            processes with statuses such as <i>Approval</i>, <i>Denial</i>, <i>Withdrawal</i>, etc. No further status
            updates will be provided. However, visa bulletin and other alerts can still be set to receive email
            notifications.
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}
